module.exports = __webpack_public_path__ + "70d14cb97adbd913e48c2ac22acdf782.jpg";